export default "__VITE_ASSET__BVRZZNTi__"